import React, { Component } from 'react'
import FormInput from './FormInput';

class Question extends Component {
    render() {
        return (
            <div style={{ marginTop: 32 }}>
                <div>
                    <FormInput
                        label="Question"
                        onChange={(text) => {
                            let { value } = this.props;
                            this.props.onChange({ description: text, value })
                        }}
                        value={this.props.description}
                        placeholder="Question description here" />
                </div>
                <div>
                    <FormInput
                        label="Answer"
                        onChange={(text) => {
                            let { description } = this.props;
                            this.props.onChange({ description, value: text })
                        }}
                        value={this.props.value}
                        placeholder="Answer here" />
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/components/Question.js